import { queryOptions } from "@tanstack/react-query";
import instance from "./axiosInstance";
import { WaterMeasurementProtocol } from "types/waterMeasurementProtocol/waterMeasurementProtocol.type";
import { CreateWaterMeasurementProtocolDto } from "types/waterMeasurementProtocol/createWaterMeasurementProtocol.dto";
import { PatchWaterMeasurementProtocolDto } from "types/waterMeasurementProtocol/patchWaterMeasurementProtocol.dto";

const ENDPOINT = "/water-measurement-protocol";

export enum WaterMeasurementProtocolQueryKey {
  GetOne = "get-water-measurement-protocol",
}

export const getWaterMeasurementProtocol = (id: number) =>
  queryOptions({
    queryKey: [WaterMeasurementProtocolQueryKey.GetOne, id],
    queryFn: async (): Promise<WaterMeasurementProtocol> =>
      (await instance.get(`${ENDPOINT}/${id}`)).data,
  });

export const createWaterMeasurementProtocol = () => ({
  mutationFn: async (
    data: CreateWaterMeasurementProtocolDto,
  ): Promise<WaterMeasurementProtocol> =>
    (await instance.post(ENDPOINT, data)).data,
});

type PatchWaterMeasurementProtocolData = {
  id: number;
  payload: PatchWaterMeasurementProtocolDto;
};

export const patchWaterMeasurementProtocol = () => ({
  mutationFn: async ({
    id,
    payload,
  }: PatchWaterMeasurementProtocolData): Promise<WaterMeasurementProtocol> =>
    (await instance.patch(`${ENDPOINT}/${id}`, payload)).data,
});

export interface AddWaterMeasurementProtocolFilesPayload {
  protocolId: number;
  files: {
    name: string;
    url: string;
    nameWithoutExtension?: string;
    extension?: string;
  }[];
}

export const addWaterMeasurementProtocolOtherFiles = () => ({
  mutationFn: async ({
    protocolId,
    files,
  }: AddWaterMeasurementProtocolFilesPayload): Promise<WaterMeasurementProtocol> =>
    (await instance.post(`${ENDPOINT}/${protocolId}/other-files`, { files }))
      .data,
});

export const addWaterMeasurementProtocolLabFiles = () => ({
  mutationFn: async ({
    protocolId,
    files,
  }: AddWaterMeasurementProtocolFilesPayload): Promise<WaterMeasurementProtocol> =>
    (await instance.post(`${ENDPOINT}/${protocolId}/lab-files`, { files }))
      .data,
});

export interface DeleteWaterMeasurementProtocolFilePayload {
  protocolId: number;
  fileId: number;
}

export const deleteWaterMeasurementProtocolFile = () => ({
  mutationFn: async ({
    protocolId,
    fileId,
  }: DeleteWaterMeasurementProtocolFilePayload): Promise<WaterMeasurementProtocol> =>
    (await instance.delete(`${ENDPOINT}/${protocolId}/files/${fileId}`)).data,
});

export const deleteWaterMeasurementProtocol = () => ({
  mutationFn: async (id: number): Promise<void> =>
    (await instance.delete(`${ENDPOINT}/${id}`)).data,
});
